(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["acordeon-info"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('acordeon-info')) return;

    class AcordeonInfo extends HTMLElement {
      connectedCallback() {
        if (this.iniciado) return;
        this.iniciado = true;
        this.sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.querySelectorAll('.acordeon-info__elemento').forEach((elemento) => {
          const cabecera = elemento.querySelector('.acordeon-info__cabecera');
          cabecera.addEventListener('click', (evento) => {
            evento.preventDefault();
            if (elemento.dataset.animando === 'si') return;
            if (elemento.open) {
              this.cerrar(elemento);
            } else {
              if (this.dataset.soloUno === 'si') {
                this.querySelectorAll('.acordeon-info__elemento[open]').forEach((otro) => {
                  if (otro !== elemento) this.cerrar(otro);
                });
              }
              this.abrir(elemento);
            }
          });
        });
      }

      abrir(elemento) {
        const contenido = elemento.querySelector('.acordeon-info__contenido');
        elemento.open = true;
        if (this.sinMovimiento || !contenido.animate) return;
        const altura = contenido.scrollHeight;
        elemento.dataset.animando = 'si';
        const animacion = contenido.animate(
          [{ height: '0px', opacity: 0 }, { height: altura + 'px', opacity: 1 }],
          { duration: 280, easing: 'ease-out' }
        );
        animacion.onfinish = () => {
          elemento.dataset.animando = 'no';
        };
      }

      cerrar(elemento) {
        const contenido = elemento.querySelector('.acordeon-info__contenido');
        if (this.sinMovimiento || !contenido.animate) {
          elemento.open = false;
          return;
        }
        const altura = contenido.scrollHeight;
        elemento.dataset.animando = 'si';
        const animacion = contenido.animate(
          [{ height: altura + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
          { duration: 240, easing: 'ease-in' }
        );
        animacion.onfinish = () => {
          elemento.open = false;
          elemento.dataset.animando = 'no';
        };
      }
    }

    customElements.define('acordeon-info', AcordeonInfo);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["selector-variantes"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('selector-variantes')) return;

    class SelectorVariantes extends HTMLElement {
      connectedCallback() {
        if (this.iniciado) return;
        this.iniciado = true;

        const datos = this.querySelector('[data-sv-variantes]');
        try {
          this.variantes = JSON.parse(datos ? datos.textContent : '[]');
        } catch (error) {
          this.variantes = [];
        }

        this.grupos = Array.from(this.querySelectorAll('[data-sv-grupo]'));
        this.seleccion = this.grupos.map((grupo) => {
          const activa = grupo.querySelector('.selector-variantes__opcion--activa');
          return activa ? activa.dataset.valor : null;
        });
        this.raiz = this.closest('product-info') || this.closest('.shopify-section') || document;

        this.ocultarSelectorNativo();

        this.grupos.forEach((grupo, indice) => {
          const pista = grupo.querySelector('[data-sv-pista]');

          grupo.addEventListener('click', (evento) => {
            const flecha = evento.target.closest('[data-sv-flecha]');
            if (flecha) {
              const direccion = Number(flecha.dataset.svFlecha);
              pista.scrollBy({ left: direccion * pista.clientWidth * 0.8, behavior: 'smooth' });
              return;
            }
            const boton = evento.target.closest('.selector-variantes__opcion');
            if (!boton || !grupo.contains(boton)) return;
            if (boton.dataset.valor === this.seleccion[indice]) return;
            this.elegir(indice, boton.dataset.valor);
          });

          pista.addEventListener('scroll', () => this.actualizarFlechas(grupo), { passive: true });
        });

        if ('ResizeObserver' in window) {
          this.observador = new ResizeObserver(() => this.grupos.forEach((grupo) => this.actualizarFlechas(grupo)));
          this.grupos.forEach((grupo) => this.observador.observe(grupo.querySelector('[data-sv-pista]')));
        }

        this.actualizarEstado();
        this.desplazarAActivas();
        this.grupos.forEach((grupo) => this.actualizarFlechas(grupo));
        this.suscribir();
      }

      disconnectedCallback() {
        this.iniciado = false;
        if (this.observador) this.observador.disconnect();
        if (typeof this.desuscribir === 'function') this.desuscribir();
        this.desuscribir = null;
      }

      buscarVariante(seleccion) {
        return this.variantes.find((variante) => seleccion.every((valor, i) => variante.options[i] === valor));
      }

      elegir(indice, valor) {
        let nueva = this.seleccion.slice();
        nueva[indice] = valor;
        let variante = this.buscarVariante(nueva);

        if (!variante) {
          const candidatas = this.variantes.filter((v) => v.options[indice] === valor);
          const puntuar = (v) => {
            let puntos = v.available ? 100 : 0;
            v.options.forEach((opcion, i) => {
              if (i !== indice && opcion === this.seleccion[i]) puntos += 1;
            });
            return puntos;
          };
          const mejor = candidatas.sort((a, b) => puntuar(b) - puntuar(a))[0];
          if (mejor) {
            nueva = mejor.options.slice(0, this.grupos.length);
            variante = mejor;
          }
        }

        this.seleccion = nueva;
        this.actualizarEstado();
        this.desplazarAActivas();
        this.aplicarEnTema(indice, variante);
      }

      actualizarEstado() {
        this.grupos.forEach((grupo, indice) => {
          grupo.querySelectorAll('.selector-variantes__opcion').forEach((boton) => {
            const valor = boton.dataset.valor;
            const activa = valor === this.seleccion[indice];
            const disponible = this.variantes.some((v) =>
              v.available &&
              v.options[indice] === valor &&
              this.seleccion.every((seleccionado, i) => i === indice || v.options[i] === seleccionado)
            );
            boton.classList.toggle('selector-variantes__opcion--activa', activa);
            boton.classList.toggle('selector-variantes__opcion--agotada', !disponible);
            boton.setAttribute('aria-checked', activa ? 'true' : 'false');
          });

          const valorActual = grupo.querySelector('[data-sv-valor-actual]');
          if (valorActual && this.seleccion[indice] !== null) valorActual.textContent = this.seleccion[indice];
        });
      }

      desplazarAActivas() {
        this.grupos.forEach((grupo) => {
          const pista = grupo.querySelector('[data-sv-pista]');
          const activa = grupo.querySelector('.selector-variantes__opcion--activa');
          if (!pista || !activa) return;
          const inicio = activa.offsetLeft;
          const fin = inicio + activa.offsetWidth;
          if (inicio < pista.scrollLeft || fin > pista.scrollLeft + pista.clientWidth) {
            pista.scrollTo({ left: Math.max(0, inicio - 8), behavior: 'smooth' });
          }
        });
      }

      actualizarFlechas(grupo) {
        const carrusel = grupo.querySelector('[data-sv-carrusel]');
        const pista = grupo.querySelector('[data-sv-pista]');
        if (!carrusel || !pista) return;
        const maximo = pista.scrollWidth - pista.clientWidth;
        carrusel.classList.toggle('selector-variantes__carrusel--con-anterior', pista.scrollLeft > 2);
        carrusel.classList.toggle('selector-variantes__carrusel--con-siguiente', maximo > 2 && pista.scrollLeft < maximo - 2);
      }

      obtenerSelectorNativo() {
        return this.raiz.querySelector('variant-selects, variant-radios');
      }

      ocultarSelectorNativo() {
        this.raiz.querySelectorAll('variant-selects, variant-radios').forEach((elemento) => {
          elemento.style.setProperty('display', 'none', 'important');
        });
      }

      marcarNativo(nativo, indice, valor, valorId) {
        const controles = nativo.querySelectorAll('fieldset, select');
        const control = controles[indice];
        if (!control) return null;
        const coincide = (elemento) => (valorId && elemento.dataset.optionValueId === valorId) || elemento.value === valor;

        if (control.tagName === 'SELECT') {
          const opciones = Array.from(control.options);
          const opcion = opciones.find(coincide);
          if (!opcion) return null;
          opciones.forEach((o) => {
            o.selected = o === opcion;
            o.toggleAttribute('selected', o === opcion);
          });
          return control;
        }

        const entrada = Array.from(control.querySelectorAll('input[type="radio"]')).find(coincide);
        if (!entrada) return null;
        entrada.checked = true;
        return entrada;
      }

      aplicarEnTema(indiceCambiado, variante) {
        const nativo = this.obtenerSelectorNativo();

        if (nativo) {
          let disparador = null;
          this.seleccion.forEach((valor, i) => {
            const boton = Array.from(this.grupos[i].querySelectorAll('.selector-variantes__opcion')).find((b) => b.dataset.valor === valor);
            const control = this.marcarNativo(nativo, i, valor, boton ? boton.dataset.valorId : '');
            if (i === indiceCambiado) disparador = control;
          });
          if (disparador) {
            disparador.dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }
        }

        this.aplicarSinTema(variante);
      }

      aplicarSinTema(variante) {
        if (!variante) return;

        this.raiz.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach((entrada) => {
          entrada.value = variante.id;
          entrada.disabled = false;
          entrada.dispatchEvent(new Event('change', { bubbles: true }));
        });

        this.raiz.querySelectorAll('form[action*="/cart/add"] [type="submit"]').forEach((boton) => {
          boton.disabled = !variante.available;
        });

        if (window.location.pathname.indexOf('/products/') !== -1) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variante.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      suscribir() {
        const intentar = () => {
          if (this.desuscribir || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
          this.desuscribir = subscribe(PUB_SUB_EVENTS.variantChange, (evento) => {
            const datos = evento && evento.data ? evento.data : {};
            const seccion = this.raiz.dataset ? this.raiz.dataset.section : null;
            if (seccion && datos.sectionId && datos.sectionId !== seccion) return;
            this.ocultarSelectorNativo();
            if (!datos.variant || !Array.isArray(datos.variant.options)) return;
            this.seleccion = datos.variant.options.slice(0, this.grupos.length);
            this.actualizarEstado();
            this.desplazarAActivas();
          });
        };

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', intentar, { once: true });
        } else {
          intentar();
        }
      }
    }

    customElements.define('selector-variantes', SelectorVariantes);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-compra"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('sticky-compra')) return;

    class StickyCompra extends HTMLElement {
      connectedCallback() {
        if (this.iniciado) return;
        this.iniciado = true;

        const origen = this.closest('product-info') || this.closest('.shopify-section') || document;
        this.botonPrincipal = origen.querySelector('product-form [type="submit"], .product-form__submit') || document.querySelector('.product-form__submit');

        try {
          this.variantes = JSON.parse(this.querySelector('[data-sc-variantes]').textContent);
        } catch (error) {
          this.variantes = [];
        }

        this.barra = this.querySelector('[data-sc-barra]');
        this.hoja = this.querySelector('[data-sc-hoja]');
        this.formulario = this.querySelector('[data-sc-formulario]');
        this.campoId = this.querySelector('[data-sc-id]');
        this.boton = this.querySelector('[data-sc-boton]');
        this.selectores = Array.from(this.querySelectorAll('[data-sc-opcion]'));
        this.control = new AbortController();
        const opciones = { signal: this.control.signal };

        document.querySelectorAll('body > sticky-compra').forEach((otro) => {
          if (otro !== this) otro.remove();
        });
        if (this.parentElement !== document.body) document.body.appendChild(this);

        this.querySelector('[data-sc-abrir]').addEventListener('click', () => {
          if (this.dataset.unica === 'si') {
            this.enviar();
          } else {
            this.abrir();
          }
        }, opciones);

        this.querySelectorAll('[data-sc-cerrar]').forEach((elemento) => {
          elemento.addEventListener('click', () => this.cerrar(), opciones);
        });

        this.selectores.forEach((selector) => {
          selector.addEventListener('change', () => this.alCambiarOpcion(), opciones);
        });

        this.boton.addEventListener('click', () => {
          if (this.boton.disabled) return;
          window.setTimeout(() => this.cerrar(), 0);
        }, opciones);

        document.addEventListener('keydown', (evento) => {
          if (evento.key === 'Escape' && this.classList.contains('sticky-compra--abierta')) this.cerrar();
        }, opciones);

        this.observar();
        this.suscribir();
        this.alCambiarOpcion();
      }

      disconnectedCallback() {
        if (this.isConnected) return;
        this.iniciado = false;
        if (this.control) this.control.abort();
        if (this.observador) this.observador.disconnect();
        if (typeof this.desuscribir === 'function') this.desuscribir();
        document.documentElement.classList.remove('sticky-compra-bloqueado');
      }

      observar() {
        const alternar = (visible) => {
          this.classList.toggle('sticky-compra--visible', visible);
          this.barra.setAttribute('aria-hidden', visible ? 'false' : 'true');
          this.querySelector('[data-sc-abrir]').tabIndex = visible ? 0 : -1;
        };

        if (this.botonPrincipal && 'IntersectionObserver' in window) {
          this.observador = new IntersectionObserver((entradas) => {
            entradas.forEach((entrada) => {
              alternar(!entrada.isIntersecting && entrada.boundingClientRect.top < 0);
            });
          });
          this.observador.observe(this.botonPrincipal);
          return;
        }

        const revisar = () => alternar(window.scrollY > 600);
        window.addEventListener('scroll', revisar, { passive: true, signal: this.control.signal });
        revisar();
      }

      abrir() {
        this.focoPrevio = document.activeElement;
        this.classList.add('sticky-compra--abierta');
        this.hoja.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('sticky-compra-bloqueado');
        this.hoja.focus({ preventScroll: true });
      }

      cerrar() {
        if (!this.classList.contains('sticky-compra--abierta')) return;
        this.classList.remove('sticky-compra--abierta');
        this.hoja.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('sticky-compra-bloqueado');
        if (this.focoPrevio && typeof this.focoPrevio.focus === 'function') this.focoPrevio.focus({ preventScroll: true });
      }

      enviar() {
        if (this.boton.disabled) return;
        if (typeof this.formulario.requestSubmit === 'function') {
          this.formulario.requestSubmit(this.boton);
        } else {
          this.formulario.submit();
        }
      }

      buscarVariante(valores) {
        return this.variantes.find((variante) => valores.every((valor, i) => variante.opciones[i] === valor));
      }

      alCambiarOpcion() {
        if (!this.selectores.length) {
          this.pintar(this.variantes.find((v) => String(v.id) === this.campoId.value) || this.variantes[0]);
          return;
        }
        const valores = this.selectores.map((selector) => selector.value);
        this.pintar(this.buscarVariante(valores));
      }

      pintar(variante) {
        const textoBoton = this.dataset.textoBoton;

        if (!variante) {
          this.boton.disabled = true;
          this.boton.textContent = this.dataset.textoNoDisponible;
          return;
        }

        this.campoId.value = variante.id;
        this.boton.disabled = !variante.disponible;
        this.boton.textContent = variante.disponible ? textoBoton : this.dataset.textoAgotado;

        this.querySelectorAll('[data-sc-precio]').forEach((el) => { el.innerHTML = variante.precio; });
        this.querySelectorAll('[data-sc-comparado]').forEach((el) => {
          el.innerHTML = variante.comparado;
          el.hidden = !variante.comparado;
        });
        this.querySelectorAll('[data-sc-insignia]').forEach((el) => {
          el.textContent = this.dataset.textoDescuento.split('[porcentaje]').join(String(variante.descuento));
          el.hidden = !(variante.descuento > 0);
        });
        if (variante.imagen) {
          this.querySelectorAll('[data-sc-imagen]').forEach((img) => { img.src = variante.imagen; });
        }
      }

      suscribir() {
        const intentar = () => {
          if (this.desuscribir || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
          this.desuscribir = subscribe(PUB_SUB_EVENTS.variantChange, (evento) => {
            const datos = evento && evento.data ? evento.data : {};
            if (!datos.variant || !Array.isArray(datos.variant.options)) return;
            const variante = this.variantes.find((v) => String(v.id) === String(datos.variant.id));
            if (!variante) return;
            this.selectores.forEach((selector, i) => {
              if (variante.opciones[i] !== undefined) selector.value = variante.opciones[i];
            });
            this.pintar(variante);
          });
        };

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', intentar, { once: true });
        } else {
          intentar();
        }
      }
    }

    customElements.define('sticky-compra', StickyCompra);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["stock-urgencia"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('stock-urgencia')) return;

    class StockUrgencia extends HTMLElement {
      connectedCallback() {
        if (this.iniciado) return;
        this.iniciado = true;

        const datos = this.querySelector('[data-su-inventario]');
        try {
          this.inventario = JSON.parse(datos ? datos.textContent : '{}');
        } catch (error) {
          this.inventario = {};
        }

        this.mensaje = this.querySelector('[data-su-mensaje]');
        this.raiz = this.closest('product-info') || this.closest('.shopify-section') || document;
        this.suscribir();
      }

      disconnectedCallback() {
        this.iniciado = false;
        if (typeof this.desuscribir === 'function') this.desuscribir();
        this.desuscribir = null;
      }

      actualizar(idVariante) {
        const info = idVariante ? this.inventario[String(idVariante)] : null;
        const umbral = Number(this.dataset.umbral) || 0;
        const textoBase = this.dataset.texto || '';
        const textoCantidad = this.dataset.textoCantidad || '';

        let visible = Boolean(info && info.disponible);
        if (this.dataset.modo === 'inventario') {
          visible = Boolean(info && info.disponible && info.gestionado && info.cantidad > 0 && info.cantidad <= umbral);
        }

        let texto = textoBase;
        if (textoCantidad && info && info.gestionado && info.cantidad > 0) {
          texto = textoCantidad.split('[cantidad]').join(String(info.cantidad));
        }

        if (this.mensaje) this.mensaje.textContent = texto;
        this.classList.toggle('stock-urgencia--oculto', !visible);
      }

      suscribir() {
        const intentar = () => {
          if (this.desuscribir || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
          this.desuscribir = subscribe(PUB_SUB_EVENTS.variantChange, (evento) => {
            const datos = evento && evento.data ? evento.data : {};
            const seccion = this.raiz.dataset ? this.raiz.dataset.section : null;
            if (seccion && datos.sectionId && datos.sectionId !== seccion) return;
            if (!datos.variant) {
              this.classList.add('stock-urgencia--oculto');
              return;
            }
            this.actualizar(datos.variant.id);
          });
        };

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', intentar, { once: true });
        } else {
          intentar();
        }
      }
    }

    customElements.define('stock-urgencia', StockUrgencia);
  })();
  } catch(e) { console.error(e); }
})();

})();
